import React from 'react';
import { Card, Box } from '@mui/material';

const YoutubeCard = ({ url, width = 400, height = 225 }) => (
  <Card
    sx={{
      backgroundColor: '#fff',
      borderRadius: 2,
      boxShadow: 0,
      p: 2,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: width,
    }}
  >
    <Box sx={{ width: '100%', maxWidth: width }}>
      <Box sx={{ position: 'relative', width: '100%', paddingTop: `${(height / width) * 100}%` }}>
        <iframe
          src={url}
          title="YouTube video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: 8,
          }}
        />
      </Box>
    </Box>
  </Card>
);

export default YoutubeCard; 